import React from "react";
import { Helmet } from "react-helmet-async";
import Slider from "../../Slider/Slider";
import MiddleBanner from "../../Middlebanner/Middlebanner";
import CourseContent from "../../Course/Course";
import Flip from "../../Flip/Flip";
import KnownUs from "../../Known/Exitknown";
import "./Home.css";
import Mid from "./mid";


const Home = () => {


  return (
    <>
      <Helmet>

        <title>Kitkat Software Technologies | Smart Software & Digital Solutions in Coimbatore</title>

        <meta name="description"
          content="KitKat Tech delivers smart software and digital solutions in Coimbatore, including web development, mobile apps and IT services to drive real business growth." />
        <meta name="keywords" content="Software development, IT company, Software company in coimbatore, Software company, IT services, Software services, IT support, Tech solutions, Digital solutions, Software solutions, IT consulting, Custom software, Business software, Enterprise software" />

        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://kitkatsoftwaretechnologies.com/" />

        {/* <!-- Hreflang Tags --> */}
        <link rel="alternate" hrefLang="en-US" href="https://kitkatsoftwaretechnologies.com/" />
        <link rel="alternate" hrefLang="en-GB" href="https://kitkatsoftwaretechnologies.com/" />
        <link rel="alternate" hrefLang="en-MY" href="https://kitkatsoftwaretechnologies.com/" />
        <link rel="alternate" hrefLang="en-SG" href="https://kitkatsoftwaretechnologies.com/" />
        <link rel="alternate" hrefLang="en-AE" href="https://kitkatsoftwaretechnologies.com/" />
        <link rel="alternate" hrefLang="x-default" href="https://kitkatsoftwaretechnologies.com/" />

      </Helmet>

      <div className="commonHome">
        <Slider />
        <KnownUs />
        <MiddleBanner />
        <Mid />
        <CourseContent />
        <Flip />
      </div>
    </>
  );
};

export default Home;
